import React, { ReactNode, FC } from 'react'

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    // extends React's HTMLAttributes
    bgcolor?: any
    border?: any
    margin?: any
    align?: any
    padding?: any
  }
}

interface ICellProps {
  style?: React.CSSProperties
  className?: string
  width?: string
  bgcolor?: string
  align?: 'left' | 'center' | 'right' | 'justify' | 'char'
  padding?: string
  colSpan?: number
}

export const Cell: React.FC<ICellProps> = ({
  children,
  style = {},
  className,
  width,
  bgcolor,
  align,
  padding,
  colSpan
}) => {
  return (
    <td
      style={style}
      className={className}
      bgcolor={bgcolor}
      width={width}
      align={align}
      padding={padding}
      colSpan={colSpan}
    >
      {children}
    </td>
  )
}
export interface IProps {
  children?: ReactNode
  style?: React.CSSProperties
  bgcolor?: string
}

export const Row: FC<IProps> = ({ children, style = {} }) => {
  return (
    <tr style={style}>
      {React.Children.map(children, (el) => {
        return el
      })}
    </tr>
  )
}

const Grid = ({ children, style = {} }: IProps) => {
  return (
    <table
      cellPadding="0"
      cellSpacing="0"
      border="0"
      margin="0"
      padding="0"
      align="center"
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        ...style
      }}
    >
      <tbody>
        {React.Children.map(children, (el) => {
          if (!el) {
            return
          }
          return el
        })}
      </tbody>
    </table>
  )
}

export default Grid
